<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="accountUsersSelected"
    :clearable="!unclearable"
    :items="accountUsersItems"
    :loading="accountUsersLoading"
    :search-input.sync="accountUsersSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="
      noLabel
        ? ''
        : createrName
        ? $t('Announcement.creater_name')
        : $t('AccountUser.title')
    "
    :return-object="notReturnObject ? false : true"
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import AccountUsers from "@/api/account_users";
import i18n from "@/i18n";

export default {
  name: "SearcherAccountUser",

  props: {
    value: [Object, Number],
    type: Array,
    noLabel: Boolean,
    createrName: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    notReturnObject: Boolean,
    description: Boolean,
  },

  computed: {
    accountUsersItems() {
      return this.accountUsers.map((user) => {
        var Description = "";
        if (this.description) {
          Description = i18n.t("AccountUser.Description", [
            user.name,
            user.organization ? user.organization.name : "",
          ]);
        } else {
          Description = user.name;
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == user.id
            )
          : false;
        return Object.assign({}, user, { Description, disabled });
      });
    },
  },

  data: () => ({
    accountUsers: [],
    accountUsersLoading: false,
    accountUsersSearch: "",
    accountUsersSelected: null,
  }),

  mounted() {
    this.getAccountUsersFromAPI();
  },

  methods: {
    getAccountUsersFromAPI() {
      this.accountUsersLoading = true;
      AccountUsers.fetchAll({
        type: this.type,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.accountUsers = response.data.account_users;
            }
            this.accountUsersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.accountUsersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.accountUsersSelected = this.value;
      },
    },
    accountUsersSelected: {
      handler() {
        this.$emit("input", this.accountUsersSelected);
      },
    },
    type: {
      handler() {
        // this.getAccountUsersFromAPI();
      },
    },
  },
};
</script>
